import React from 'react';

const LaneLabelNode = ({ data }) => {
  return <div className="mc-demo-lane-chip">{data?.label || ''}</div>;
};

export default LaneLabelNode;
